import { render } from "./AsetHandling.vue?vue&type=template&id=8ccb116e"
import script from "./AsetHandling.vue?vue&type=script&lang=js"
export * from "./AsetHandling.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__